export const CookieService = {
  setCookie(name, value, days) {
    if (typeof document !== "undefined") {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + ';';
    }
  },
  getCookie(name) {
    if (typeof document !== "undefined") {
      const cookies = document.cookie.split(";");
      for (const cookie of cookies) {
        if (cookie.indexOf(name + "=") > -1) {
          return cookie.split("=")[1];
        }
      }
    }
    return null;
  }
};
export const whatsappPhoneNumber = 5511935853846;